import { MARKETINGDATA__MUTATIONS } from "../mutation-types";
import { MARKETINGDATA__ACTIONS } from "../action-types";
import { MARKETINGDATA__API } from "@/_helpers/urls";
import HTTP from "@/_helpers/http";
import toast from "@/services/Notification";

// State
const state = {
  marketingusers: [],
  allEmailsCustom: [],
  allemails: [],
};

// Mutations
const mutations = {
  [MARKETINGDATA__MUTATIONS.GETMARKETINGUSERS](state, data) {
    state.marketingusers = data;
  },

  [MARKETINGDATA__MUTATIONS.GETALLEMAIL](state, data) {
    state.allEmailsCustom = data;
  },

  [MARKETINGDATA__MUTATIONS.GETEMAILSBYCATEGORY](state, payload) {
    state.allemails = payload;
  },
};

const getters = {};

// Actions
const actions = {
  async [MARKETINGDATA__ACTIONS.GETMARKETINGUSERS]({ commit }) {
    try {
      const response = await HTTP().get(MARKETINGDATA__API.GETMARKETINGUSERS);
      commit(MARKETINGDATA__MUTATIONS.GETMARKETINGUSERS, response.data);
    } catch (error) {
      console.error(error);
    }
  },

  async [MARKETINGDATA__ACTIONS.GETALLEMAIL]({ commit }) {
    try {
      const response = await HTTP().get(MARKETINGDATA__API.GETALLEMAIL);
      commit(MARKETINGDATA__MUTATIONS.GETALLEMAIL, response.data);
    } catch (error) {
      console.error(error);
    }
  },

  async [MARKETINGDATA__ACTIONS.GETEMAILSBYCATEGORY]({ commit }, payload) {
    const res = await HTTP().get(MARKETINGDATA__API.GETEMAILSBYCATEGORY, {
      params: payload
    });
    const list = res.data?.data || [];
    commit(MARKETINGDATA__MUTATIONS.GETEMAILSBYCATEGORY, list);
    return list;
  },

  async [MARKETINGDATA__ACTIONS.FILEUPLOAD]({ commit, dispatch }, formData) {
    try {
      const response = await HTTP().post(
        MARKETINGDATA__API.FILEUPLOAD,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      await dispatch(MARKETINGDATA__ACTIONS.GETMARKETINGUSERS);
      toast.success(response?.data?.message || "File Uploaded Successfully");
    } catch (error) {
      console.error(error);
    }
  },

  async [MARKETINGDATA__ACTIONS.SENDEMAIL]({ commit, dispatch }, parameter) {
    try {
      const response = await HTTP().post(
        MARKETINGDATA__API.SENDEMAIL,
        parameter
      );

      toast.success(response?.data?.message);
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
